
import React, { useState, useEffect, useRef } from 'react';
import { Button, Popup, ScrollView } from 'devextreme-react';
import { useDispatch, useSelector } from 'react-redux';
import Form, { EmptyItem, GroupItem, Item, Label, RequiredRule, SimpleItem, StringLengthRule } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';

import { closeDialog, openItemDialog, setItemTypeId } from '../../store/item/itemDialogReducer'
import { store } from '../../services/store';
import uri from '../../utils/uri';
import { createCustomStore, createStore } from '../../utils/proxy';
import http from '../../utils/http';
import HtmlEditor, { Toolbar, MediaResizing } from 'devextreme-react/html-editor';
import { catalogosConocidos, tipoArticulos, catalogoValores } from '../../data/catalogos';
import LensItemProperties from './LensItemProperties';
import { esferas, cilindros, reChanges } from '../../utils/custom';
import { useBarcode } from 'react-barcodes';
import urlReport from '../../services/reportServices';
import { closeDialogScleral } from '../../store/scleral/scleralDialogReducer';
import { case_insensitive_comp } from '../../utils/common';
import { editorOptionsNumberBox } from '../../data/app';


const defualtItem = {
    id: 0,
    name: '',
    description: '',
    productNumber: '',
    typeId: null,
    safetyStockLevel: 0,
    reorderPoint: 0,
    unitMeasure: 0,
    currency: '',
    price: 0,
    cost: 0,
    quantity: 0,
    markup: '',
    brandId: null,
    modelId: null,
    profitPercent: 0,
    code: 0,
    preview: '',
    modelScleralId: null,
    typeScleralId: null,
    itemTypes: [],
    lensItem: {
        type: null,
        subType: null,
        material: null,
        treatment: null,
        color: null
    },
    contactLensItem: {
        type: null,
        sphere: null,
        cylinder: null,
        radius: null,
        diameter: null,
        power: null
    },
    frameItem: {
        size: null,
        color: null,
        frameType: null,
        frameHeight: null
    },
    maintenanceItem: {
        subType: null,
        indications: null
    },
    scleralItem: {
        type: 1, //esta campo ya no se usa
        baseCurve: null,
        sagita: null,
        diameter: null,
        power: null,
        cylinder: null,
        sphere: null,
        axis: null,
    },
    areaProductStock: {
        price: 0,
        costAvg: 0
    },
    catalogs: []
};


const catalogs = [
    catalogosConocidos.MarcaLenteOftalmico,
    catalogosConocidos.ModeloLenteOftalmico,
    catalogosConocidos.MarcaLenteContacto,
    catalogosConocidos.ModeloLenteContacto,
    catalogosConocidos.TipoLente,
    catalogosConocidos.SubTipoLente,
    catalogosConocidos.Material,
    catalogosConocidos.Tratamiento,
    catalogosConocidos.Color,
    catalogosConocidos.AlturaMarco,
    catalogosConocidos.TipoMarco,
    catalogosConocidos.SubTipoMantenimiento,
    catalogosConocidos.TipoLenteContacto,
    catalogosConocidos.MarcaMarcoAro,
    catalogosConocidos.ModeloMarcoAro,
    catalogosConocidos.MarcaAccesorio,
    catalogosConocidos.MarcaLentesEsclerales,
    catalogosConocidos.ModeloLentesEsclerales,
    catalogosConocidos.TipoLentesEsclerales,
    catalogosConocidos.DisenoLenteEsclerales
]

const ScleralNuevo = (props) => {

    const { updateParent } = props;
    defualtItem.typeId = props.typeId;

    let dispatch = useDispatch();

    const [saving, setSaving] = useState(false);
    const [item, setsItem] = useState(defualtItem);

    const { scleral: { open, id }, appInfo } = useSelector((store) => store);
    const isNew = id === 0;

    const formRef = useRef();

    const { inputRef } = useBarcode({
        value: `${item.code}`,
        options: {
            height: 20
        }
    });

    const closeDialog = () => {
        dispatch(closeDialogScleral());
    }

    const onBrandChanged = ({ value }) => {
        setsItem(prev => {
            return {
                ...prev,
                brandId: value,
                preview: getPreview({ ...prev, brandId: value })
            };
        });
    }

    const onModelChanged = ({ value }) => {
        setsItem(prev => {
          return {
            ...prev,
            modelId: value,
            preview: getPreview({ ...prev, modelId: value })
          };
        });
      }

    const onModelScleralChanged = ({ value }) => {
        setsItem(prev => {
            return {
                ...prev,
                modelScleralId: value,
                preview: getPreview({ ...prev, modelScleralId: value })
            };
        });
    }

    const onTypeChanged = ({ value }) => {
        setsItem(prev => {
            return {
                ...prev,
                typeScleralId: value,
                preview: getPreview({ ...prev, typeScleralId: value })
            };
        });
    }

    const onCostChanged = (e) => {

        setsItem(prev => {

            return {
                ...prev,
                areaProductStock: {
                    ...prev.areaProductStock,
                    costAvg: e.value,
                    price: (e.value + e.value * prev.profitPercent).toFixed(2)
                }
            };
        });
    }


    const onProfitPercentChanged = (e) => {
        setsItem(prev => {

            return {
                ...prev,
                profitPercent: e.value,
                areaProductStock: {
                    ...prev.areaProductStock,
                    price: (prev.areaProductStock.costAvg + e.value * prev.areaProductStock.costAvg).toFixed(2)
                }
            };
        });
    }

    const getPreview = (it) => {

        let preview = '';

        const catalog = (id) => {
            let v = it.catalogs.find(e => e.id == id)?.value;
            if (v && v != 'Ninguno')
                preview == '' ? (preview = v) : (preview += (' - ' + v));
        }

        if (it.modelId)
            catalog(it.modelId);

        if (it.modelId)
            catalog(it.modelScleralId);

        if (it.modelId)
            catalog(it.typeScleralId);

        return preview;
    }

    const guardarItem = (params) => {

        if (formRef.current.instance.validate().isValid) {
            var data = {
                ...item,
                itemTypeProperties: null,
                type: null,
                lensItem: null,
                contactLensItem: null,
                frameItem: null,
                maintenanceItem: null,
                scleralItem: item.scleralItem,
            }

            setSaving(true);
            http(uri.items.insert).asPost(data).then(resp => {
                notify('Datos guardados correctamente');
                updateParent();
                clearItem();
                setSaving(false);
                closeDialog();
            }).catch(err => {
                setSaving(false);
                notify(err, 'error');
            }
            )
        }
    }

    const clearItem = () => {

        setsItem(prev => {
            return {
                ...defualtItem,
                lensItem: { ...defualtItem.lensItem },
                contactLensItem: { ...defualtItem.contactLensItem },
                frameItem: { ...defualtItem.frameItem },
                maintenanceItem: { ...defualtItem.maintenanceItem },
                scleralItem: { ...defualtItem.scleralItem },
                areaProductStock: { ...defualtItem.areaProductStock },
                profitPercent: appInfo.profitPercent,
                catalogs: [...prev.catalogs]
            };
        })
    }

    const loadCatalogs = async () => {

        const [_itemTypes, _catalogs] = await Promise.all([
            http(uri.itemTypes.get).asGet(),
            http(uri.catalogEntriesByNames).asPost(catalogs)
        ]);

        setsItem(prev => {
            return {
                ...prev,
                itemTypes: _itemTypes,
                catalogs: _catalogs
            }
        });


    }

    const onLoad = () => {

        Promise.all([
            http(uri.itemValues(id)).asGet(),
            http(uri.itemTypes.get).asGet(),
            http(uri.catalogEntriesByNames).asPost(catalogs)
        ]).then(result => {
            let r = {
                ...item,
                ...result[0],
                itemTypes: result[1],
                catalogs: result[2]
            };
            if (r.areaProductStock == null)
                r.areaProductStock = { price: 0, costAvg: 0 };

            setsItem(r);
        });
    }

    useEffect(() => {

        if (id > 0)
            onLoad();
        else
            clearItem();


    }, [open]);

    useEffect(() => {
        loadCatalogs();
    }, []);

    const title = isNew ? 'Nuevo Artículo' : 'Editar Artículo';

    //const baseCurveText = item.modelId == 138 ? 'Curva Base' : 'Fit/Stp';

    const isScleral2 = item.modelId != 138;

    return (

        <Popup
            width={900}
            height={null}
            title={title}
            visible={open}
            onHiding={closeDialog}>
            <ScrollView showScrollbar="onScroll">
                <Form formData={item} ref={formRef}>

                    <GroupItem cssClass="second-group" colCount={2}>

                        <SimpleItem dataField="brandId" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.MarcaLentesEsclerales), valueExpr: "id", displayExpr: "value", onValueChanged: onBrandChanged, defaultValue: null }}>
                            <Label text="Marca" />
                        </SimpleItem>

                        <SimpleItem dataField="modelId" editorType="dxSelectBox"
                            editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.DisenoLenteEsclerales && x.parentId == item.brandId), valueExpr: "id", displayExpr: "value", defaultValue: null, 
                            onValueChanged: onModelChanged }}>
                            <Label text="Diseño de lente" />
                            <RequiredRule message="Este campo es requerido" />
                        </SimpleItem>

                        <SimpleItem dataField="modelScleralId" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.ModeloLentesEsclerales && x.parentId == item.modelId ).sort(case_insensitive_comp), valueExpr: "id", displayExpr: "value", 
                            onValueChanged: onModelScleralChanged, defaultValue: null,searchEnabled: true }}>
                            <Label text="Modelo" />
                            <RequiredRule message="Este campo es requerido" />
                        </SimpleItem>

                        <SimpleItem dataField="typeScleralId" editorType="dxSelectBox"
                            editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.TipoLentesEsclerales && x.parentId == item.modelId), valueExpr: "id", displayExpr: "value", defaultValue: null, 
                            onValueChanged: onTypeChanged }}>
                            <Label text="Tipo" />
                        </SimpleItem>


                        {
                            !isScleral2 &&
                            <SimpleItem dataField="scleralItem.baseCurve" editorType="dxNumberBox" editorOptions={{...editorOptionsNumberBox}} ><Label text='Curva Base' /></SimpleItem>
                        }                        
                        
                        {   isScleral2 &&
                            <SimpleItem dataField="scleralItem.fltStp" editorOptions={{...editorOptionsNumberBox}} ><Label text='Fit/Stp' /></SimpleItem>
                        }
                        <SimpleItem dataField="scleralItem.sagita" editorType="dxNumberBox" editorOptions={{...editorOptionsNumberBox}}><Label text="Sagita" /></SimpleItem>
                        <SimpleItem dataField="scleralItem.diameter" editorType="dxNumberBox" editorOptions={{...editorOptionsNumberBox}}><Label text="Diametro" /></SimpleItem>
                        <SimpleItem dataField="scleralItem.power" editorType="dxNumberBox" editorOptions={{...editorOptionsNumberBox}}><Label text="Poder" /></SimpleItem>
                        <SimpleItem dataField="description" colSpan={2} editorType="dxTextBox">
                            <Label text="Nota" />
                            <StringLengthRule max={500} message="Maximo 500 caracteres" />
                        </SimpleItem>
                    </GroupItem>

                    {/* <GroupItem cssClass="second-group" colCount={3} caption="Sobre Refreacción">
                        <SimpleItem dataField="scleralItem.sphere" editorType="dxNumberBox" colSpan={1}><Label text="Esfera" /></SimpleItem>
                        <SimpleItem dataField="scleralItem.cylinder" editorType="dxNumberBox" colSpan={1}><Label text="Cilindro" /></SimpleItem>
                        <SimpleItem dataField="scleralItem.axis" editorType="dxNumberBox" colSpan={1}><Label text="Eje" /></SimpleItem>
                    </GroupItem> */}

                    <GroupItem cssClass="second-group" colCount={3} caption="Costos">
                        <SimpleItem dataField="areaProductStock.costAvg" colSpan={1} editorType="dxNumberBox" editorOptions={{ onValueChanged: onCostChanged }} >
                            <Label text="Costo" />
                            <RequiredRule message="Este campo es requerido" />
                        </SimpleItem>

                        <SimpleItem dataField="profitPercent" colSpan={1} editorType="dxNumberBox" editorOptions={{ step: 0.01, format: "#0%", onValueChanged: onProfitPercentChanged, showSpinButtons: true }}>
                            <Label text="% de ganancia" />
                            <RequiredRule message="Este campo es requerido" />
                        </SimpleItem>

                        <SimpleItem dataField="areaProductStock.price" colSpan={1} editorType="dxNumberBox">
                            <Label text="Precio Vta" />
                        </SimpleItem>
                    </GroupItem>
                </Form>

                <div>
                    <p>Previsualización: <strong>{item.preview} </strong></p>
                </div>



              
                <div className='footer-dialog'>
                    <div>
                        <svg ref={inputRef} height={100} />
                    </div>
                    <Button
                        disabled={saving}
                        width={180}
                        text={'Imprimir código'}
                        type="normal"
                        stylingMode="text"
                        icon='print'
                        onClick={() => {

                            const report = urlReport();
                            report.print(report.itemsCodeBar(item.id));

                        }}
                    />
                    <Button
                        disabled={saving}
                        width={180}
                        text={saving ? 'Guardando...' : 'Guardar'}
                        type="default"
                        icon='save'
                        onClick={guardarItem}
                    />
                </div>
                <br />

            </ScrollView>
        </Popup >

    );
};


ScleralNuevo.propTypes = {

};


export default ScleralNuevo;
